"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getArrayIfSingleItem = void 0;
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */

exports.getArrayIfSingleItem = function (mayBeArray) {
  return Array.isArray(mayBeArray) ? mayBeArray : [mayBeArray];
};